import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import CalculatePage from "./components/CalculatePage";
import TreningPage from "./components/TreningPage";
import Page1650 from "./components/Page1650";
import PlanPage from "./components/PlanPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/calculate" element={<CalculatePage />} />
          <Route path="/trening" element={<TreningPage />} />
          <Route path="/1650" element={<Page1650 />} />
          <Route path="/plan" element={<PlanPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;